import React, { useEffect, useState } from "react";
import { Form, FormControl, FormLabel, Row } from "react-bootstrap";
import "./DeliverychargesPage.css";
import popup from "./../../../assets/popup.webp";
import delivery_tr from "../../../assets/delivery_tr.png";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { fetchStoredetail } from "../../dashboard/redux/actions";
import { postRequestcall } from "../../comman/util/postRequest";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  DELIVERY_CHARGES,
  STOREDELIVERY_CHARGES,
} from "../../constants/apiurl";
import ButtonPage from "../../comman/button/ButtonPage";
import { clearStoredetail } from "../../dashboard/redux/actions";
import { useNavigate } from "react-router-dom";
import "rc-time-picker/assets/index.css";
import { fetchLogindata } from "../../login/redux/actions";
import DateTimeInput from "../../comman/DateTimeInput";
const HelpPage = React.lazy(() => import("../../modal/components/HelpPage"));
const DeletepopupPage = React.lazy(() =>
  import("../../modal/components/DeletepopupPage")
);
// const getStandardTime = (times) =>{
//   const currentDate = new Date();
//   const timeString = times;
//   const [time, meridiem] = timeString.split(' ');
//   const [hours, minutes] = time.split(':');
//   let parsedHours = parseInt(hours, 10);
//   if (meridiem.toLowerCase() === 'pm' && parsedHours !== 12) {
//     parsedHours += 12;
//   } else if (meridiem.toLowerCase() === 'am' && parsedHours === 12) {
//     parsedHours = 0;
//   }
//   currentDate.setHours(parsedHours, parseInt(minutes, 10), 0);
//   const standardizedTime = new Date(currentDate.getTime());
//   return standardizedTime
// }
function DeliverychargesPage(props) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [errorToast, setErrorToast] = useState({ error: "" });
  const [showRange, setShowrange] = useState(true);
  const [chargesInput, setChargesInput] = useState({
    home_delivery: "yes",
    delivery_max_distance: 0,
  });
  const filed = {
    id: "",
    min_price: "",
    max_price: "",
    delivery_charge: "",
  };
  const [charges, setCharges] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteInfo, setDeleteinfo] = useState({
    title: t("pages.add_delivery.Are you sure want to delete ?"),
    sub_title: "",
    name: "",
    id: "",
    type: "",
  });

  // const [fromtime, setFormtime] = useState("");
  // const [totime, setTotime] = useState("");
  const [selectedFormDate, setSelectedFormDate] = useState("");
  const [selectedToDate, setSelectedToDate] = useState("");
  const [maxtime, setMaxtime] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    callStoreDeliverycharges();
    // eslint-disable-next-line
  }, [props?.language]);

  useEffect(() => {
    props?.fetchHeaderContent(t("pages.sidenav.delivery"), "", "");
    setDeleteinfo({
      ...deleteInfo,
      title: t("pages.add_delivery.Are you sure want to delete ?"),
      sub_title: "",
      name: "",
      id: "",
      type: "",
    });
    // eslint-disable-next-line
  }, [props?.language]);

  const callStoreDeliverycharges = async () => {
    let responce = await getRequestcall(`${STOREDELIVERY_CHARGES}/${props?.storedetail?.store_id}?lang=${props.language.toLowerCase()}`,
      props?.access_token
    );
    if (responce?.status === 200) {
      let resultStoreCharges = await responce?.json();
      let chargesStore = resultStoreCharges?.data;
      setChargesInput({
        home_delivery: chargesStore?.home_delivery,
        delivery_max_distance:
          chargesStore?.delivery_max_distance === null
            ? 0
            : chargesStore?.delivery_max_distance,
      });
      // After delivery max time chamge update the store detail for delivey max time for show
      let object = {
        ...props.storedetail,
        delivery_max_time: chargesStore?.delivery_max_time,
      };
      await props.fetchStoredetail(object);
      setMaxtime(Number(chargesStore?.delivery_max_time));
      if (chargesStore?.working_hours_from !== null) {
        const standardizedTime = chargesStore?.working_hours_from
        setSelectedFormDate(standardizedTime)
        // console.log("chargesStore?.working_hours_from ", standardizedTime)
      }else{
        setSelectedFormDate(new Date());
      }
      if (chargesStore?.working_hours_to !== null) {
        const standardizedTime = chargesStore?.working_hours_to;
        setSelectedToDate(standardizedTime)
      }else{
        setSelectedToDate(new Date());
      }
      let data = chargesStore?.charges?.map((item) => {
        return {
          delivery_charge: item?.delivery_charge,
          max_price: item?.max_price,
          min_price: item?.min_price,
          id: item?.id,
        };
      });
      if (data?.length === 0) {
        setCharges([]);
      } else {
        setShowrange(true);
        setCharges(data);
      }
    } else if (responce?.status === 400) {
      let getError = await responce.json();
      if (getError?.error?.is_deleted === true) {
        props?.clearStoredetail([]);
        props.logindata.type = "user";
        props.fetchLogindata(props.logindata);
        toast.error(getError?.errors);
        navigate("/vendor/");
      } else {
        toast.error(getError?.errors);
      }
      setSelectedToDate(new Date());
      setSelectedFormDate(new Date());
      setChargesInput({
        home_delivery: "yes",
        delivery_max_distance: 0,
      });
    }
  };

  const addChargesList = () => {
    if (chargesInput?.home_delivery === "yes") {
      if (charges?.length === 0) {
        const dataFileds = {
          ...filed,
          min_price: 0.01,
          max_price: 100
        };
        setCharges([...charges, dataFileds]);
      } else if(onCheckEditStateChange(charges?.length - 1)){
        const lastIndex = charges?.length - 1;
        if(!charges[lastIndex]?.max_price){
          charges[lastIndex].max_price = 100
        }
        const dataFileds = {
          ...filed,
          min_price: parseFloat(charges[lastIndex]?.max_price)+0.01,
          max_price: "",
        };
        setCharges([...charges, dataFileds]);
      }else{
      toast?.error(t("pages.Please check all charges are filled properly"));

      }
    } else {
      toast?.info(t("pages.add_delivery.Check yes for adding range"));
    }
  };
  const itemDelete = () => {
    const data = charges.filter((item, index1) => index1 !== deleteInfo.id);
    setCharges([...data]);
    setDeleteModal(false);
  };

  const removeRange = (index) => {
    setDeleteinfo({
      ...deleteInfo,
      id: index,
      type: "order",
    });
    setDeleteModal(true);
  };

  const onChangeChecked = (e) => {
    if (e === "no") {
      setShowrange(false);
      setChargesInput({ ...chargesInput, home_delivery: e });
    } else {
      setShowrange(true);
      setChargesInput({ ...chargesInput, home_delivery: e });
    }
  };

  const onCheckEditStateChange = (index) => {
    const addCharges = charges[index];
    let value = true;
    if (addCharges?.delivery_charge === "") {
      errorToast.error = "pages.add_delivery.Enter delivery charges";
      value = false;
    }
    if (Number(addCharges?.min_price) >= Number(addCharges?.max_price)) {
      errorToast.error =
        "pages.add_delivery.Min price should not greater than max price";
      value = false;
    }
    if (addCharges?.max_price === "") {
      errorToast.error = "pages.add_delivery.Enter max price";
      value = false;
    }
    if (addCharges?.min_price === "") {
      errorToast.error = "pages.add_delivery.Enter min price";
      value = false;
    }
    if (maxtime.length > 2) {
      errorToast.error = "pages.add_delivery.maxtime_warn";
      value = false;
    }
    setErrorToast({
      ...errorToast,
      error: errorToast.error,
    });
    if (value === true) {
      return value;
    } else {
      return false;
    }
  };
  const validation = () => {
    // eslint-disable-next-line
    let value = true;
    const chargeList = charges?.map((item, index) =>
      onCheckEditStateChange(index)
    );
    const result = chargeList?.filter((item) => item === false);
    if (result?.length === 0) {
      value = true;
    } else {
      value = false;
    }
    console.log("Maxtime",maxtime)
    if (maxtime.toString().length > 2) {
      errorToast.error = "pages.add_delivery.maxtime_warn";
      setErrorToast({
        ...errorToast,
        error: errorToast.error,
      });
      value = false;
    }
    if (value === true) {
      return true;
    } else {
      return false;
    }
  };

  const onAddDeliveryCharges = async (e) => {
    e.preventDefault();
    if (validation()) {

      let FromTime =  selectedFormDate.replace('ÖS', "PM");
        FromTime = FromTime.replace('ÖÖ', "AM")
      let ToTime =  selectedToDate.replace('ÖS', "PM");
        ToTime = ToTime.replace('ÖÖ', "AM")
      const payload = {
        delivery_max_distance: chargesInput?.delivery_max_distance,
        home_delivery: chargesInput?.home_delivery,
        store_id: props?.storedetail?.store_id,
        charges: chargesInput?.home_delivery === "no" ? [] : charges,
        delivery_max_time: maxtime,
        working_hours_from:FromTime,
        working_hours_to: ToTime,
      };
      // console.log("payload", payload)
      let responce = await postRequestcall(DELIVERY_CHARGES, props?.access_token, payload);
      if (responce?.status === 200) {
        toast?.success(t("pages.add_delivery.Charges added successfully"));
        callStoreDeliverycharges();
      } else if(responce?.status === 400) {
          let getError = await responce?.json();
          toast.error(getError?.errors)
      }
    } else {
      toast?.error(t(errorToast?.error));
    }
  };

  const onChangeInput = (e, index) => {
    const data = charges?.map((item, index1) => {
      if (index === index1) {
        return { ...item, [e.target?.name]: e?.target?.value };
      } else {
        return { ...item };
      }
    });
    setCharges(data);
  };
  const onChangemaxtime = (e) => {
    if (e.target.value > 0) {
      setMaxtime(e.target.value);
    } else if (e.target.value === "") {
      setMaxtime(e.target.value);
    }
  };
  const FromDateTime = ({selected, onChange, className}) =>{
    const handleChange = (e) =>{
      console.log("e", e)
      onChange(e)
    }
    return(
      <React.Fragment>
        <DateTimeInput
          formClassName={className}
          value={selected}
          type={"time"}
          onChange={(e)=>handleChange(e.target.value)}
          dateFormat={"hh:mm aa"}
          format={"hh:mm A"}
        />
      </React.Fragment>
    )
  }
  return (
    <div className="col-xl-9 mb-4 main-content delivery-contents">
      <div className="card">
        <div className="card-body p-4">
          <h5 className="font-20 mb-3">{t("pages.add_delivery.title")}</h5>
          <Form onSubmit={onAddDeliveryCharges} className="form_div ">
            <Form.Group className="mb-3">
              <FormLabel>{t("pages.add_delivery.deliver_charge")}</FormLabel>
              <div key={`inline-checkbox`} className="mb-3">
                <Form.Check
                  inline
                  id="yes"
                  type="radio"
                  name={"delivery_state"}
                  className="font-16"
                  label={t("pages.add_delivery.yes")}
                  checked={chargesInput?.home_delivery === "yes" ? true : false}
                  onChange={() => onChangeChecked("yes")}
                />
                <Form.Check
                  inline
                  id="no"
                  type="radio"
                  name={"delivery_state"}
                  className="font-16"
                  label={t("pages.add_delivery.no")}
                  checked={chargesInput?.home_delivery === "no" ? true : false}
                  onChange={() => onChangeChecked("no")}
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-4 range__slider">
              <div className="d-flex align-center justify-content-between align-items-start">
                <FormLabel>{t("pages.add_delivery.distance")}</FormLabel>
                <span className="">
                  {chargesInput?.delivery_max_distance}{" "}
                  {t("pages.add_delivery.km")}
                </span>
              </div>
              <div className="px-4 slider-range">
                <input
                  type={"range"}
                  className={"rangeslider"}
                  min={0}
                  max={15}
                  value={chargesInput?.delivery_max_distance}
                  onChange={(e) =>
                    setChargesInput({
                      ...chargesInput,
                      delivery_max_distance: e.target.value,
                    })
                  }
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-4 range__slider">
              <div className="d-flex align-center justify-content-between align-items-start">
                <FormLabel>{t("pages.storedetail.about.workhours")}</FormLabel>
              </div>
              
              {props?.language === "Tr" ? (
                <div>
                  <FromDateTime
                    selected={selectedFormDate}
                    onChange={setSelectedFormDate}
                    className="time_picker ms-0"
                  />
                  <FormLabel className="ms-2">
                    {t("pages.add_delivery.To")}
                  </FormLabel>
                   <FromDateTime
                    selected={selectedToDate}
                    onChange={setSelectedToDate}
                    className="time_picker ms-5"
                  />
                  <FormLabel className="ms-2">
                    {" "}
                    {t("pages.add_delivery.From")}
                  </FormLabel>
                </div>
              ) : (
                <div className="selection-time">
                  <FormLabel>{t("pages.add_delivery.From")} </FormLabel>
                  <FromDateTime
                    selected={selectedFormDate}
                    onChange={setSelectedFormDate}
                    className={"time_picker ms-2"}
                  />
                  <FormLabel className="ms-5 to-time">
                    {t("pages.add_delivery.To")}
                  </FormLabel>
                  <FromDateTime
                    selected={selectedToDate}
                    onChange={setSelectedToDate}
                    className="time_picker ms-2"
                  />
                </div>
              )}
            </Form.Group>
            <Form.Group className="mb-4 range__slider">
              <div className="d-flex align-center justify-content-between align-items-start">
                <FormLabel>
                  {t("pages.add_delivery.Delivery max time (In hours)")}
                </FormLabel>
              </div>
              <FormControl
                className=""
                placeholder="Ex 12"
                type={"number"}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => onChangemaxtime(e)}
                value={maxtime}
              />
            </Form.Group>
            {showRange && (
              <>
                <Form.Group className="mb-3 ">
                  <div className="d-flex align-center justify-content-between align-items-start">
                    <FormLabel>
                      {t("pages.add_delivery.charges_title")}
                    </FormLabel>
                    <span
                      onClick={() => setShowModal(true)}
                      className="pr-color hover"
                    >
                      {t("pages.add_delivery.help")}
                    </span>
                  </div>
                </Form.Group>

                <div className="charges-list">
                  {charges.map((item, index) => (
                    <Row
                      key={index.toString()}
                      className="form-charges transition"
                    >
                      <Form.Group className="mb-2 col-6 col-sm-3 col-md-3 col-lg-3 col-lx-3">
                        <FormLabel>
                          {t("pages.add_delivery.minprice")}
                        </FormLabel>
                        <FormControl
                          placeholder={t("pages.add_delivery.minprice_place")}
                          className="font-14"
                          type={"number"}
                          onWheel={(e) => e.target.blur()}
                          name={"min_price"}
                          value={item?.min_price}
                          onChange={(e) => onChangeInput(e, index)}
                          disabled={index === 0 ?false:true}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3 col-6 col-sm-3 col-md-3 col-lg-3 col-lx-3">
                        <FormLabel>
                          {t("pages.add_delivery.maxprice")}
                        </FormLabel>
                        <FormControl
                          className="font-14"
                          placeholder={t("pages.add_delivery.maxprice_place")}
                          type={"number"}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => onChangeInput(e, index)}
                          name={"max_price"}
                          value={item?.max_price}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3 col-6 col-sm-4 col-md-4 col-lg-4 col-lx-4">
                        <FormLabel>{t("pages.add_delivery.charges")}</FormLabel>
                        <FormControl
                          className="font-14"
                          placeholder={t("pages.add_delivery.charges_place")}
                          type={"number"}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => onChangeInput(e, index)}
                          name={"delivery_charge"}
                          value={item?.delivery_charge}
                        />
                      </Form.Group>
                      <div className="d-flex align-center justify-content-end  col">
                        <button
                          type="button"
                          onClick={() => removeRange(index)}
                          className="icon-button"
                        >
                          <i className="mask_icon delete_svg white" />
                        </button>
                      </div>
                    </Row>
                  ))}
                </div>
                <div className="mb-3 d-flex">
                  <p
                    className="pr-color hover"
                    onClick={() => addChargesList()}
                  >
                    <i className="icon_after plus_icon d-inline-block pr-color" />
                    {" "}
                    {t("pages.add_delivery.add_range")}
                  </p>
                </div>
              </>
            )}
            <div className="form-submit d-flex justify-content-end mb-3">
              <ButtonPage
                Text={
                  t("pages.add_delivery.submit")
                }
                className={`button-submit hover-btn`}
                type={"submit"}
              />
            </div>
          </Form>
        </div>
      </div>
      {showModal && (
        <HelpPage
          showModal={showModal}
          setShowModal={setShowModal}
          image={props.language === "Tr" ? delivery_tr : popup}
        />
      )}
      {deleteModal && (
        <DeletepopupPage
          setDeleteModal={setDeleteModal}
          deleteInfo={deleteInfo}
          deleteModal={deleteModal}
          itemDelete={itemDelete}
        ></DeletepopupPage>
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  storedetail: state?.dashboard?.storeDetail,
  language: state?.languageState?.language,
  logindata: state?.login?.logindata
});

export default connect(mapStateToProps, {
  fetchHeaderContent,
  fetchStoredetail,
  clearStoredetail,
  fetchLogindata
})(DeliverychargesPage);
